import moment from 'moment';

export const convertDate = date => moment(date).format("YYYY-MM-DD HH:mm:ss");

export const convertToIso = date => new Date(date).toISOString();
